import React, { Component } from 'react';
const showdown  = require('showdown')
//const ReactMarkdown = require('react-markdown')

export default function(markdown)
{
    const converter = new showdown.Converter();
    return <span dangerouslySetInnerHTML={{ __html: drawHorizontalLine(converter.makeHtml(markdown)) }} />;
}

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function drawHorizontalLine(html) {

    if(!html)
        return;

    let result = html.replaceAll('-----red', '<hr class="hlong red">')
    result = result.replaceAll('----red', '<hr class="hmiddle red">')
    result = result.replaceAll('---red', '<hr class="hshort red">')
    result = result.replaceAll('--red', '<hr class="hshortest red">')
    result = result.replaceAll('-----', '<hr class="hlong">')
    result = result.replaceAll('----', '<hr class="hmiddle">')
    result = result.replaceAll('---', '<hr class="hshort">')
    result = result.replaceAll('--', '<hr class="hshortest">')

    return result

}

// export default function(markdown)
// {
//     return <ReactMarkdown source={markdown} />
// }